// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedChatRouteImport } from './routes/_authed/chat'
import { Route as AuthedSettingsRouteImport } from './routes/_authed/settings'
import { Route as AuthedOidcRedeemTokenRouteImport } from './routes/_authed/oidc/redeem-token'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthedRoute = AuthedRouteImport.update({
            id: '/_authed',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const AuthedChatRoute = AuthedChatRouteImport.update({
            id: '/chat',path: '/chat',getParentRoute: () => AuthedRoute
          })
const AuthedSettingsRoute = AuthedSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthedRoute
          })
const AuthedOidcRedeemTokenRoute = AuthedOidcRedeemTokenRouteImport.update({
            id: '/oidc/redeem-token',path: '/oidc/redeem-token',getParentRoute: () => AuthedRoute
          })





const AuthedRouteChildren = {
  AuthedChatRoute: AuthedChatRoute,AuthedSettingsRoute: AuthedSettingsRoute,AuthedOidcRedeemTokenRoute: AuthedOidcRedeemTokenRoute
}

const AuthedRouteWithChildren = AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthedRoute: AuthedRouteWithChildren,LoginRoute: LoginRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)